import { useQuery } from '@tanstack/vue-query'
import { computed, watch, type ComputedRef } from 'vue'

import { selectGetSelectedProgramId } from '@/features/programs/stores/programs/programs.selectors'
import programsStore from '@/features/programs/stores/programs/programs.store'
import { V1_USER_QUERY_KEY, V1GetUser } from '@/features/users/api'
import type { V1UserDataType, V2UserDetailsDataType } from '@/features/users/types'

export function V1ToV2UserDataMiddleware(data?: Partial<V1UserDataType>): Partial<V2UserDetailsDataType> | undefined {
  if (!data) return undefined
  return {
    id: data.user?.id,
    firstName: data.user?.identity?.firstname,
    lastName: data.user?.identity?.lastname,
    picture: data.user?.personalInformation?.profilPicture,
    roles: data.roles,
    title: data.user?.description?.title,
    description: data.user?.description?.value,
    matchingCriteria: data.user?.matchingCriterias?.length ? data.user?.matchingCriterias : undefined,
  }
}

const useUser = (userIdRef: ComputedRef<string | undefined>) => {
  const programIdRef = selectGetSelectedProgramId(programsStore)
  const isUserIdDefinedRef = computed(() => !!userIdRef.value)
  const isProgramIdDefinedRef = computed(() => !!programIdRef.value)
  const isUseUserQueryEnabledRef = computed(() => isUserIdDefinedRef.value && isProgramIdDefinedRef.value)
  const userQuery = useQuery({
    queryKey: [V1_USER_QUERY_KEY, { userId: userIdRef, programId: programIdRef }],
    queryFn: () => V1GetUser(userIdRef.value!, programIdRef.value!),
    enabled: isUseUserQueryEnabledRef,
  })

  // watch(programIdRef, (programId) => {
  //   if (programId) {
  // userQuery.refetch()
  //   }
  // })

  const data = computed(() => V1ToV2UserDataMiddleware(userQuery.data.value))

  return {
    userRef: data,
    isPendingRef: userQuery.isPending,
  }
}

export default useUser
